export default "__VITE_ASSET__93fffb0b__"